import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{
        backgroundColor: "#0A0A0A",
        borderTop: "1px solid #1A1A1A",
        padding: "48px 24px",
        marginTop: "64px",
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "32px",
        }}
      >
        <div>
          <p
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "11px",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "#A1A1AA",
              marginBottom: "8px",
            }}
          >
            Macroeconomics Research Project
          </p>
          <p style={{ color: "#52525B", fontSize: "13px" }}>
            Research Question: How does government regulation affect businesses,
            workers, and consumers in the U.S. economy?
          </p>
        </div>
        <nav style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {[
            { label: "Home", path: "/" },
            { label: "Background", path: "/background" },
            { label: "Impact: Businesses", path: "/impact-businesses" },
            { label: "Impact: Workers", path: "/impact-workers" },
            { label: "Impact: Consumers", path: "/impact-consumers" },
            { label: "MLA Citations", path: "/citations" },
          ].map((link) => (
            <Link
              key={link.path}
              to={link.path}
              style={{
                fontSize: "13px",
                color: "#52525B",
                textDecoration: "none",
                transition: "color 0.15s",
              }}
              data-testid={`footer-link-${link.label.replace(/[: ]/g, "-").toLowerCase()}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
      <div
        style={{
          maxWidth: "1280px",
          margin: "32px auto 0",
          borderTop: "1px solid #1A1A1A",
          paddingTop: "24px",
        }}
      >
        <p
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "11px",
            color: "#3F3F46",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          }}
        >
          Macroeconomics — Spring 2025 — Due May 7/8
        </p>
      </div>
    </footer>
  );
}
